import { DataService } from './../../../services/data.service';
import { RouteDataService } from './../../../services/route-data.service';
import { CommonService } from 'app/services/common.service';
import { WebService } from './../../../services/web.service';
import { NotificationService } from './../../../services/notification.service';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { LoginInfoProvider } from '../../../ev-dal/login-info.provider';



@Component({
  selector: 'app-act-score-list',
  templateUrl: './act-score-list.component.html',
  styleUrls: [
    '../score.scss',
    './act-score-list.component.scss' 
  ]
})
export class ActScoreListComponent implements OnInit {

  @Input() studentProfileId: any;

  bsConfig: Partial<BsDatepickerConfig> = Object.assign({}, { containerClass: 'theme-default' });
  profileId: string;

  scoreSchema = this.dataService.getEntity('ACT');
  grades = this.dataService.getEntity('Student Grade');

  maxDate = new Date();
  date: Date;
  loader = false;
  showSort = [false];
  arrayOfData = [];
  isLoader = false;


  constructor(
    private notificationService: NotificationService,
    private webService: WebService,
    private authService: LoginInfoProvider,
    private commonService: CommonService,
    private routeService: RouteDataService,
    private dataService: DataService,
  ) { }


  ngOnInit() {
    this.profileId = this.studentProfileId ? this.studentProfileId : this.authService.userId;
    this.getScores();
  }

  // get ACT score list
  getScores() {
    this.isLoader = true;
    this.loader = true;
    const inputJson = {
      studentUserId: this.profileId,
      testClassId: this.scoreSchema.id,
      partnerId: this.authService.partnerId,
      userId: this.authService.userId
    };

    this.webService.post('student/testscore/list', inputJson)
      .subscribe(
        (data: any) => {
          this.isLoader = false;
          this.loader = false;
          if (data && data.items && JSON.parse(data.items)[0] && JSON.parse(data.items).length > 0) {
            this.arrayOfData = this.formatResponse(data);
          } else {
            this.isLoader = false;
            this.arrayOfData = [];
          }
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while fetching data');
        });
  }

  // delete ACT test score
  deleteScore(data) {
    const inputJson = {
      studentUserId: this.profileId,
      testClassId: this.scoreSchema.id,
      showOrder: data.ShowOrder,
      partnerId: this.authService.partnerId,
      userId: this.authService.userId
    };
    this.loader = true;
    this.webService.post('student/testscore/list', inputJson)
      .subscribe(
        () => {
          this.loader = false;
          this.getScores();
          this.routeService.testScoreUpdate.next();
          this.notificationService.show('success', 'Score deleted successfully!');
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while deleting data');
        });
  }

  // save new ACT score
  saveScore(form: NgForm) {
    if (form && form.valid) {
      const inputJson = {
        partnerId: this.authService.partnerId,
        userId: this.authService.userId,
        studentUserId: this.profileId,
        testTypeClassId: this.scoreSchema.id.toString(),
        item: [],
        testtaken: this.date
      };

      for (let i = 0; i < this.scoreSchema.item.length; i++) {

        if (this.scoreSchema.item[i] && this.scoreSchema.item[i].value && ((this.scoreSchema.item[i].value.split(',')[3] === 'Composite' && (!this.scoreSchema.item[i].result || this.scoreSchema.item[i].result === '0')))) {
          this.notificationService.show('error', 'At least fill a composite score');
          return null;
        }

        inputJson.item.push({
          subject: this.scoreSchema.item[i].id.toString(),
          // tslint:disable-next-line:no-bitwise
          result: this.scoreSchema.item[i].value.split(',')[1].trim() === 'C' ? ~~(this.scoreSchema.item[i].result) : (this.scoreSchema.item[i].result ? this.scoreSchema.item[i].result.toString() : '0')
        })
      }
      this.loader = true;
      this.webService.post('student/testscore/save', inputJson)
        .subscribe(
          () => {
            this.loader = false;
            this.routeService.testScoreUpdate.next();
            this.getScores();
            form.reset();
            this.date = undefined;
            this.notificationService.show('success', 'Your ACT score saved successfully');
          },
          () => {
            this.loader = false;
            this.notificationService.show('error', 'Error while calling service');
          });
    } else {
      this.loader = false;
      this.notificationService.show('error', 'Please fill all score fields');
    }
  }

  // Additional functionality (need refactoring)
  formatResponse(data) {
    const scoreArray = JSON.parse(data.items);

    for (let i = 0; i < scoreArray.length; i++) {
      if (scoreArray[i]['Grade Level']) {
        scoreArray[i]['Grade Level'] = this.getGradeById(scoreArray[i]['Grade Level']);
      }

      if (scoreArray[i]['Writing'] === '1') {
        scoreArray[i]['Writing'] = 'Yes';
      } else {
        scoreArray[i]['Writing'] = 'No';
      }
    }

    return scoreArray;
  }

  getGradeById(id) {
    const grade = this.grades.item.find(element => element.value === id);

    return grade ? grade.text : '0';
  }

  getComposite(data, index, event) {
    if (data.text === 'Composite') {
      if (event.key !== 'Tab') {
        this.scoreSchema.item[0].result = '';
        this.scoreSchema.item[1].result = '';
        this.scoreSchema.item[2].result = '';
        this.scoreSchema.item[3].result = '';
      }
      if (data.result > 36) {
        this.notificationService.show('info', 'Max value of Composite score is 36');
        this.scoreSchema.item[index].result = '';
      }
    } else {
      if (data.result > 36) {
        this.notificationService.show('info', 'Max value of score is 36');
        this.scoreSchema.item[index].result = '';
      }

      this.calculateComposite(this.scoreSchema.item);
    }
  }

  calculateComposite(data) {
    let total = 0;
    let counter = 0;
    let index;

    for (let i = 0; i < data.length; i++) {
      if (data[i].text !== 'Composite' && data[i].value.split(',')[1] === 'T') {
        total += data[i].result;
        counter++;
      } else if (data[i].text === 'Composite') {
        index = i;
      }
    }

    data[index].result = Math.round(total / counter);
  }

  sortTable(orderBy, columnName, order) {
    this.showSort[order] = !this.showSort[order];
    this.arrayOfData.sort(this.commonService.dynamicSort(columnName, false));
  }
}

